export default "__VITE_ASSET__df686f35__"